const aluminium = [];  // No products have images in the catalog

export default aluminium;
